import React, { useState, useEffect } from "react";
import "./style.css";
import Table from "react-bootstrap/Table";
import Moment from "react-moment";
import API from "../../utils/API";
import { storage } from "../../config/Fire";
import cogoToast from "@successtar/cogo-toast";

function UmbrellaPolicySummary({ umbrellaData, colSize, admin }) {
  const [formData, setFormData] = useState({
    editActivated: false,
    showUmbrella: false,
    uploaded: undefined,
    carrier: "",
    policyNumber: "",
    effectiveDate: "",
    liability: "",
    premium: "",
    declaration: ""
  });

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      carrier: umbrellaData.carrier,
      policyNumber: umbrellaData.policyNumber,
      effectiveDate: umbrellaData.effectiveDate,
      liability: umbrellaData.liability,
      premium: umbrellaData.premium,
      declaration: umbrellaData.declaration
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const copyText = (event, data) => {
    event.preventDefault();
    if (data !== undefined) {
      navigator.clipboard.writeText(data);
      cogoToast.success("Copied: " + data);
    } else {
      cogoToast.error("Couldn't copy data");
    }
  };

  const fileSelectedHandler = (event) => {
    event.preventDefault();
    if (event.target.files[0]) {
      setFormData((prev) => ({
        ...prev,
        declaration: event.target.files[0]
      }));
    }
  };

  const fileUploadHandlerB = (event) => {
    setFormData((prev) => ({
      ...prev,
      uploaded: false
    }));
    event.preventDefault();
    const uploadTask = storage.ref(`*/${formData.declaration.name}`).put(formData.declaration);
    uploadTask.on(
      "state_changed",
      (_snapshot) => {},
      (error) => {
        console.log(error);
      },
      () => {
        storage
          .ref("*")
          .child(formData.declaration.name)
          .getDownloadURL()
          .then((urlB) => {
            setFormData((prev) => ({
              ...prev,
              declaration: urlB,
              uploaded: true
            }));
          });
      }
    );
  };

  const activateEdit = (e) => {
    e.preventDefault();
    setFormData((prev) => ({
      ...prev,
      editActivated: !prev.editActivated
    }));
  };

  const saveEdits = (e) => {
    e.preventDefault();
    API.updateUmbrellaPolicy(umbrellaData._id, {
      carrier: formData.carrier,
      policyNumber: formData.policyNumber,
      liability: formData.liability,
      premium: parseInt(formData.premium),
      declaration: formData.declaration
    })
      .then((_res) => {
        alert("You've updated this policy!");
      })
      .catch((_err) => alert("The edit did not go through!"));
  };

  const softDeleteUmbrella = (id) => {
    API.softDeleteUmbrella(id)
      .then((_res) => {
        alert("You've deleted this umbrella policy");
      })
      .catch((_err) => alert("The deletion did not go through"));
  };

  const showUmbrella = () => {
    setFormData((prev) => ({
      ...prev,
      showUmbrella: !prev.showUmbrella
    }));
  };

  return (
    <div className={colSize}>
      {umbrellaData.policyActive ? (
        <div className="card" style={{ overflow: "auto" }}>
          <div className="card-header" style={{ textAlign: "center", color: "black" }}>
            <h5>
              <strong>{umbrellaData.carrier} Umbrella</strong>
            </h5>
            <h6>
              <strong>Policy #: {umbrellaData.policyNumber}</strong>
            </h6>
            <button className="btn btn-success" onClick={showUmbrella}>
              Show / Hide
            </button>
            {admin ? (
              <button className="btn btn-warning" onClick={activateEdit}>
                Edit
              </button>
            ) : null}
            {admin ? (
              <button
                className="btn-danger btn"
                onClick={() => softDeleteUmbrella(umbrellaData._id)}
              >
                Delete
              </button>
            ) : null}
          </div>

          {formData.editActivated ? (
            <>
              <div className="card-body" style={{ backgroundColor: "white" }}>
                <Table striped bordered hover responsive>
                  <tbody>
                    <tr>
                      <th>
                        <strong></strong>
                      </th>
                      <th>
                        <strong></strong>
                      </th>
                    </tr>
                    <tr>
                      <td>
                        <strong>Carrier</strong>
                      </td>
                      <td>
                        <input
                          type="text"
                          onChange={handleInputChange}
                          value={formData.carrier}
                          name="carrier"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Policy Number</strong>
                      </td>
                      <td>
                        <input
                          type="text"
                          onChange={handleInputChange}
                          value={formData.policyNumber}
                          name="policyNumber"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Effective Date</strong>
                      </td>
                      <td>
                        <Moment format="MM/DD/YYYY" add={{ hours: 8 }}>
                          {umbrellaData.effectiveDate}
                        </Moment>
                      </td>
                    </tr>
                  </tbody>
                </Table>

                <Table striped bordered hover responsive>
                  <tbody>
                    <tr>
                      <th>
                        <strong>Coverage</strong>
                      </th>
                      <th>
                        <strong>Amount</strong>
                      </th>
                    </tr>
                    <tr>
                      <td>
                        <strong>Excess Liability</strong>
                      </td>
                      <td>
                        $
                        <input
                          type="text"
                          onChange={handleInputChange}
                          value={formData.liability}
                          name="liability"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Premium</strong>
                      </td>
                      <td>
                        $
                        <input
                          type="number"
                          onChange={handleInputChange}
                          value={formData.premium}
                          name="premium"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Declarations</strong>
                      </td>
                      <td>
                        <input
                          style={{ width: "80%" }}
                          type="file"
                          onChange={fileSelectedHandler}
                        />
                        <button onClick={fileUploadHandlerB}>
                          Upload
                          <span>
                            {formData.uploaded === false ? (
                              <img alt="loading" src="/loading.gif" />
                            ) : null}
                            {formData.uploaded === true ? (
                              <img
                                alt="checkmark"
                                src="/checkmark.png"
                                style={{ height: "20px", width: "20px" }}
                              />
                            ) : null}
                          </span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </Table>
                <button
                  style={{ textAlign: "center" }}
                  className="btn btn-success"
                  onClick={saveEdits}
                >
                  Save Edits
                </button>
              </div>
            </>
          ) : (
            <div className="card-body" style={{ backgroundColor: "white" }}>
              {formData.showUmbrella ? (
                <>
                  <Table striped bordered hover responsive>
                    <tbody>
                      <tr>
                        <th>
                          <strong></strong>
                        </th>
                        <th>
                          <strong></strong>
                        </th>
                      </tr>
                      <tr>
                        <td>
                          <strong>Carrier</strong>
                        </td>
                        <td>{umbrellaData.carrier}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Policy Number</strong>
                        </td>
                        <td>
                          {umbrellaData.policyNumber}{" "}
                          <i
                            className="fa-solid fa-copy"
                            onClick={(e) => {
                              copyText(e, umbrellaData.policyNumber);
                            }}
                          ></i>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Effective Date</strong>
                        </td>
                        <td>
                          <Moment format="MM/DD/YYYY" add={{ hours: 8 }}>
                            {umbrellaData.effectiveDate}
                          </Moment>
                        </td>
                      </tr>
                    </tbody>
                  </Table>

                  <Table striped bordered hover responsive>
                    <tbody>
                      <tr>
                        <th>
                          <strong>Coverage</strong>
                        </th>
                        <th>
                          <strong>Amount</strong>
                        </th>
                      </tr>
                      <tr>
                        <td>
                          <strong>Excess Liability</strong>
                        </td>
                        <td>${umbrellaData.liability}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Premium</strong>
                        </td>
                        <td>${umbrellaData.premium}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Declarations Page</strong>
                        </td>
                        <td>
                          <a href={umbrellaData.declaration}>Download</a>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </>
              ) : null}
            </div>
          )}
        </div>
      ) : null}
      <br />
    </div>
  );
}

export default UmbrellaPolicySummary;
